import AttendeeList from "@/view/addin/home/attendee-list/AttendeeListContainer";
import SelectedResource from "@/view/addin/selected-resources/ResourceSelectedContainer";
import {
  HomeBaseWrapper,
  ListAttendeeWrapper,
  SelectedResourceWrapper,
} from "./Style";
import { useEffect, useRef, useState } from "react";

const Home = () => {
  const resourceDivRef = useRef(null);
  const resourceListRef = useRef(null);
  const resourceSelectedRef = useRef(null);
  const [heightResourceList, setHeightResourceList] = useState<number>(0);
  const [heightSelectedResourceList, setHeightSelectedResourceList] =
    useState(175);
    const [isOpenAttendeeList, setIsOpenAttendeeList] = useState<boolean>(true);

    useEffect(() => {
      const div = resourceSelectedRef?.current;
      if (!div) {
        return;
      }
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (resourceDivRef.current) {
            const height = (resourceDivRef.current as HTMLElement).offsetHeight;
            const cal = height - 36 - entry.contentRect.height;
            setHeightResourceList(cal);
          }
        }
      });
      observer.observe(div);
      return () => {
        observer.unobserve(div);
      };
    }, [resourceSelectedRef]);
  
    const setMaxHeightSelectedResource = (
      isOpen: boolean,
      quantity?: number
    ): void => {
      if (!isOpen) {
        const div: HTMLElement | null = resourceListRef?.current || null;
        if (!div) {
          return;
        }
        const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
          for (const entry of entries) {
            if (
              resourceDivRef.current &&
              (div as HTMLElement)?.offsetHeight === 0
            ) {
              const height: number = (resourceDivRef.current as HTMLElement)
                ?.offsetHeight;
              const cal: number = height - 160 + 48;
              setHeightSelectedResourceList(cal - (quantity || 0));
            }
          }
        });
        observer.observe(div);
      } else {
        setHeightSelectedResourceList(0);
      }
    };

    const onChangeOpenAttendeeList = (isOpen: boolean) => {
      setMaxHeightSelectedResource(isOpen);
      setIsOpenAttendeeList(isOpen);
    }

  return (
    <HomeBaseWrapper className="HomeBaseWrapper" ref={resourceDivRef}>
      <SelectedResourceWrapper
        className="SelectedResourceWrapper"
        ref={resourceSelectedRef}
      >
        <SelectedResource maxHeight={heightSelectedResourceList} />
      </SelectedResourceWrapper>
      <ListAttendeeWrapper
        className="ListAttendeeWrapper"
        ref={resourceListRef}
      >
        <AttendeeList onChangeOpenAttendeeList={onChangeOpenAttendeeList} isOpen={isOpenAttendeeList} height={heightResourceList} />
      </ListAttendeeWrapper>
    </HomeBaseWrapper>
  );
};

export default Home;
